module.exports = __webpack_public_path__ + "static/img/toolbox-bar.85c1210a.svg";